define(
    'views/admin_menu.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/admin_menu_link.html'
    ],
    function(Loader, Config, Helper, Sandbox, adminMenuTemplate)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var ForumDescriptionView = Loader.Backbone.View.extend(
            {
                routes: {
                    "/admin_": "render"
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');

                    this.model.on('startApplication', function(){
                        Helper.filterRoutes(_this.routes, _this);
                    });

                    this.model.get('adminMenuLinks').bind('change add remove', function(){
                        _this.render();
                    });
                },

                render: function()
                {
                    var _this = this;
                    this.model.get('adminMenuLinks').each(function(model){
                        var compiledTemplate = _.template(
                            adminMenuTemplate,
                            {
                                model: _this.model.toJSON(),
                                link: model.toJSON()
                            }
                        );

                        var position = model.get('position');

                        if (_this.$el.find('#'+model.id).length) {
                            _this.$el.find('#'+model.id).replaceWith(compiledTemplate);
                        }
                        else {
                            var elem = _this.$el.find('> li:eq('+position+')');
                            if (elem.length)
                                elem.before(compiledTemplate);
                            else
                                _this.$el.append(compiledTemplate);
                        }
                    });
                    return this;
                }
            });

        return {
            initialize: function(model)
            {
                return new ForumDescriptionView({
                    el: $("#adnav-standard ul:first"),
                    model: model
                })
            }
        }
    }
);
